import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [siteConfig, setSiteConfig] = useState(null);

  useEffect(() => {
    api.get("/site-config").then(({ data }) => setSiteConfig(data)).catch(() => {});
  }, []);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("dl_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("dl_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
      (async () => {
        try {
          const { data } = await api.post("/auth/google/session", { session_id: sid });
          localStorage.setItem("dl_token", data.token);
          setUser(data.user);
        } catch {
          setUser(null);
        } finally {
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
          setLoading(false);
        }
      })();
      return;
    }
    refresh();
  }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem("dl_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("dl_token");
    setUser(null);
  };

  const toggleFavourite = useCallback(async (pid) => {
    if (!localStorage.getItem("dl_token")) return null;
    const { data } = await api.post(`/favourites/${pid}`);
    setUser((u) => (u ? { ...u, favourites: data.favourites } : u));
    return data.favourited;
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, refresh, siteConfig, toggleFavourite }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
